/**
 * OpenAPI definition
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Hash } from './hash';


export interface RT2SignRequest { 
    revision: number;
    hash: Hash;
    'zb-token': string;
}

